var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"organization"},[_c('p',{staticClass:"overflow-ellipsis"},[_vm._v(_vm._s(_vm.organizationName || '-'))])])}
var staticRenderFns = []

export { render, staticRenderFns }